module.exports = __webpack_public_path__ + "static/media/effect_10.59b1fd02.png";